qw-room-type-list[qw-room-type-list-typology='list'] {
  max-width: 260px;
  border: solid 2px var(--qw-hotel-neutral-medium);
  background-color: #ffffff;
  border-radius: 5px;
  padding: 26px 30px;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
}

qw-room-type-list[qw-room-type-list-typology='list'] .qw-room-type-list__item {
  font-size: 20px;
  font-family: var(--qw-hotel-font-family-b);
  margin: 0 0 44px;
  cursor: pointer;
}
qw-room-type-list[qw-room-type-list-typology='list']
  .qw-room-type-list__item:last-of-type {
  margin: 0;
}

qw-room-type-list[qw-room-type-list-typology='select'] {
  display: inline-flex;
}

qw-room-type-list[qw-room-type-list-typology='select'] select {
  border: solid 2px var(--qw-hotel-neutral-medium);
  background-color: #ffffff;
  padding: 8px 24px 8px 16px;

  background-image: url('#{$base-url}img/icons/select-arrow.svg');
  background-repeat: no-repeat;
  background-size: 9px;
  background-position: center right 14px;
  border-radius: 100px;
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
  font-family: var(--qw-hotel-font-family-m);
  color: var(--qw-hotel-neutral-medium);
}

qw-room-type-list[qw-room-type-list-typology='select'].loading-room-list,
qw-room-type-list[qw-room-type-list-typology='select'].disable-room-list {
  pointer-events: none;
  background-color: var(--qw-hotel-skeleton-light);
  border-radius: 100px;
  position: relative;
  box-shadow: 0px 0px 6px rgba(0, 0, 0, 0.25);
}
qw-room-type-list[qw-room-type-list-typology='select'].loading-room-list
  .qw-room-type-list__sublabel,
qw-room-type-list[qw-room-type-list-typology='select'].disable-room-list
  .qw-room-type-list__sublabel {
  opacity: 0;
}
qw-room-type-list[qw-room-type-list-typology='select'].loading-room-list select,
qw-room-type-list[qw-room-type-list-typology='select'].disable-room-list
  select {
  opacity: 0;
}

qw-room-type-list[qw-room-type-list-typology='select'].disable-room-list:after,
qw-room-type-list[qw-room-type-list-typology='select'].loading-room-list:after {
  content: '';
  display: block;
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  background: #eee;
  background: linear-gradient(
    110deg,
    rgba(255, 255, 255, 0) 12%,
    white 17%,
    rgba(255, 255, 255, 0) 22%
  );
  background-size: 600% 100%;
  background-position-x: 40%;
  animation: 3s shine linear infinite;
  opacity: 0.4;
}

@keyframes shine {
  to {
    background-position-x: -200%;
  }
}

.qw-room-type-list__item.qw-room-type-list__item--disabled {
  opacity: 0.6;
  pointer-events: none;
}

.qw-room-type-list__item.qw-room-type-list__item--disabled
  .qw-room-type-list__sublabel {
  display: block;
  font-size: 16px;
  color: var(--qw-hotel-label);
  font-family: var(--qw-hotel-font-family-r);
  margin: 0;
}

.qw-room-type-list__sublabel--select {
  display: block;
  font-size: 16px;
  color: var(--qw-hotel-neutral-medium);
  font-family: var(--qw-hotel-font-family-r);
  margin: 8px 0 0;
}

.qw-room-type-list--inline {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  padding: 0 var(--qw-hotel-gap-lg);
}

.qw-room-type-list--inline .qw-room-type-list__item {
  margin-right: var(--qw-hotel-gap-lg);
  border: 2px solid transparent;
  padding: var(--qw-hotel-gap-xs) var(--qw-hotel-gap-md);
  border-radius: 24px;
  font-size: 20px;
  font-family: var(--qw-hotel-font-family-m);
  cursor: pointer;
}
.qw-room-type-list--inline .qw-room-type-list__item:last-child {
  margin-right: 0;
}

.qw-room-type-list--inline
  .qw-room-type-list__item.qw-room-type-list__item--current {
  border: 2px solid var(--qw-hotel-neutral-dark);
}

qw-room-type-list[qw-room-type-list-typology='list'].qw-room-type-list--modal {
  border: 0;
  border-radius: 0;
  border-top: 2px solid var(--qw-hotel-primary-color);
  box-shadow: 0px 0px 5px rgb(0 0 0 / 25%);
  width: 100%;
  max-width: 100%;
  padding-top: 14px;
  padding-bottom: 14px;
}
qw-room-type-list[qw-room-type-list-typology='list'].qw-room-type-list--modal
  .qw-room-type-list__item {
  margin: 14px 0;
}
qw-room-type-list[qw-room-type-list-typology='list'].qw-room-type-list--modal
  .qw-room-type-list__item:last-of-type {
  margin: 14px 0;
}

@media only screen and (max-width: 1024px) {
  .qw-room-type-list--inline .qw-room-type-list__item {
    font-size: 18px;
    margin-right: 16px;
  }
}

@media only screen and (max-width: 924px) {
  .qw-room-type-list--inline .qw-room-type-list__item {
    font-size: 16px;
  }
}
@media only screen and (max-width: 738px) {
  qw-room-type-list[qw-room-type-list-typology='list'] {
    border: 0;
    border-radius: 0;
    border-top: 2px solid var(--qw-hotel-primary-color);
    box-shadow: 0px 0px 5px rgb(0 0 0 / 25%);
    width: 100%;
    max-width: 100%;
    padding-top: 14px;
    padding-bottom: 14px;
  }
  qw-room-type-list div,
  qw-room-type-list select {
    width: 100%;
  }
  qw-room-type-list[qw-room-type-list-typology='list']
    .qw-room-type-list__item {
    margin: 14px 0;
  }
  qw-room-type-list[qw-room-type-list-typology='list']
    .qw-room-type-list__item:last-of-type {
    margin: 14px 0;
  }
  .qw-room-type-list--inline {
    padding: 0 0 0 20px;
    max-width: 100vw;
    overflow-x: scroll;
    white-space: nowrap;
  }
  .qw-room-type-list--inline .qw-room-type-list__item {
    font-size: 14px;
    text-align: center;
    padding: 3px 14px;
  }
  .qw-room-type-list__item.qw-room-type-list__item--disabled
    .qw-room-type-list__sublabel {
    font-size: 12px;
  }
}
